var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaInfoServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1214_3163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01212 19.4289C1.29875 11.0611 4.76921 5.38504 9.71229 2.41628C12.3939 0.805714 15.5042 0 18.6089 0C21.7133 0 24.824 0.805714 27.5054 2.41628C32.448 5.38504 35.9188 11.061 35.2054 19.4289C34.8803 19.2934 34.5295 19.2195 34.1646 19.2195H33.5899C34.2134 11.6075 31.1019 6.47616 26.6695 3.81387C24.2502 2.36072 21.4318 1.63379 18.6089 1.63379C15.7862 1.63379 12.9678 2.36072 10.5482 3.81387C6.11558 6.47616 3.00411 11.6078 3.62788 19.2195H3.05288C2.68797 19.2195 2.33735 19.2934 2.01212 19.4289ZM21.2053 34.1263C21.8455 34.1263 22.4132 34.4371 22.7659 34.9158L30.245 33.5703H30.2447L30.245 33.5699C30.2443 33.5697 30.2436 33.5691 30.2447 33.5673L30.2462 33.5683L31.7127 31.1804H31.1113V20.4063H34.1646C35.8434 20.4063 37.2174 21.9709 37.2174 23.8838V27.7031C37.2174 29.616 35.8439 31.1804 34.1646 31.1804H33.6248L31.6358 34.4192V34.4222C31.5133 34.6215 31.3549 34.7875 31.1654 34.9173C30.9799 35.0436 30.7673 35.1299 30.5324 35.1721L23.09 36.5111C22.8878 37.3648 22.1208 38 21.2053 38C20.1356 38 19.2685 37.1328 19.2685 36.0631C19.2685 34.9934 20.1356 34.1263 21.2053 34.1263ZM3.05288 20.4063H6.10605V31.1804H3.05288C1.37349 31.1804 0 29.616 0 27.7031V23.8838C0 21.9709 1.37349 20.4063 3.05288 20.4063Z",
    fill: "#134046"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72583 10.3477H27.4916C28.4451 10.3477 29.2253 11.1278 29.2253 12.0812V24.0563C29.2253 25.0097 28.4451 25.79 27.4916 25.79H19.2081L14.1047 30.5351V25.79H9.72583C8.77236 25.79 7.99219 25.0098 7.99219 24.0563V12.0812C7.99219 11.1278 8.77236 10.3477 9.72583 10.3477ZM11.1293 16.9843H26.0881V18.2689H11.1293V16.9843ZM11.1293 14.0724H26.0881V15.357H11.1293V14.0724ZM11.1293 19.896H19.2761V21.1806H11.1293V19.896Z",
    fill: "#134046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1214_3163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaInfoServicesIcon);
export default __webpack_public_path__ + "static/media/media_Info_services_icon.40e20daa4045d32abccb5dc47860fb7f.svg";
export { ForwardRef as ReactComponent };